module.exports = __webpack_public_path__ + "img/fwtd-bjhxz.6c8b287d.png";